import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {ChairsOptions} from "./options/chairs.options";
import {ListResponse} from "../../../../network/service/list.response";
import {SnackBarUtil} from "../../../../util/snack.bar.util";
import {RequestType} from "../../../../enums/request.type";
import {FilterUtil} from '../../../../util/filter.util';
import {DataResponse} from '../../../../network/service/data.response';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-attribute-selector',
  standalone: false,
  templateUrl: './chairs.component.html',
  styleUrls: ['./chairs.component.scss']
})
export class ChairsComponent extends BaseComponent implements OnInit {
  chairsOptions = new ChairsOptions();
  displayedColumns = ['Delete', 'Title'];
  displayDataSources = ['delete', 'Title'];
  displayColumnTypes = ['event', 'string'];
  displayEndPoint = ['', ''];
  spaces: any = [];
  allFilters = FilterUtil.DeliveryMethodsFilters;
  filters: any = {};
  title?: any;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<ChairsComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  noAction() {
    this.matDialogRef.close();
  }

  override loadOnline() {
    super.loadOnline();
    if (!this.filters.Values) {
      this.filters.Values = [];
    }
    this.filters.Values.push({
      Field: 'Type',
      Type: 'EQ',
      Value: 'CHAIR'
    });
    this.filters.Values.push({
      Field: 'ParentId',
      Type: 'EQ',
      Value: this.chairsOptions.spaceId
    });
    this.serviceApi.getSpaces(this.tableProperties.offset, this.tableProperties.limit, '', RequestType.ALL, undefined, {
      Filter: this.filters,
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.spaces = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.spaces) {
      for (let i = 0; i < this.spaces.length; i++) {
        this.spaces[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    if (this.title) {
      this.serviceApi.createSpaces({
        Title: this.title,
        ParentId: this.chairsOptions.spaceId,
        BusinessId: this.chairsOptions.businessId,
        Type: 'CHAIR'
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    }
  }

  onDeleteClicked(index: number) {
    this.serviceApi.deleteSpaces(this.spaces[index].SpaceId).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.loadOnline();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
